import './ExtensionPanel.css'
import * as React from 'react';
import { connect } from 'react-redux';
import { PanelType } from 'office-ui-fabric-react';
import ExpandablePanel from '../ExpandablePanel';
import { EntityType, Dictionary, EXTRA_EXTRA_LARGE_PANEL_WIDTH, EXTRA_LARGE_PANEL_WIDTH, FULL_SCREEN_PANEL_WIDTH, PANEL_CUSTOM_WIDTH } from '../../../entities/common';
import { ExtensionEmbededContentSize, ExtensionInfo, ExtensionType } from '../../../store/ExtensionStore';
import { TenantState } from '../../../store/Tenant';
import { ApplicationState } from '../../../store';
import { ExtensionViewer } from './ExtensionViewer';
import ExtensionTrigger from './ExtensionTrigger';
import ExtensionNavigate from './ExtensionNavigate';

type OwnProps = { entityType: EntityType, info: ExtensionInfo, onDismiss: () => void, onRefresh?: () => void, context: Dictionary<any> }
type StateProps = { tenant: TenantState, expandSideBar: boolean, isFullScreen: boolean }

const Header = (props: {name: string}) => (
    <div className="ms-Panel-header align-center">
        <p className="ms-Panel-headerText">{props.name}</p>
    </div>
);

export const getContentAreaPanelWidth = (expandSideBar?: boolean) =>
    `calc(100vw - var(--${expandSideBar ? 'nav-sidebar-full-width' : 'nav-sidebar-width'}))`;

export const getExtensionPanelWidth = (size: ExtensionEmbededContentSize | undefined, isFullScreen?: boolean, expandSideBar?: boolean) => {
    switch (size) {
        case ExtensionEmbededContentSize.Canvas:
            return isFullScreen ? FULL_SCREEN_PANEL_WIDTH : getContentAreaPanelWidth(expandSideBar);
        case ExtensionEmbededContentSize.Small:
            return PANEL_CUSTOM_WIDTH;
        case ExtensionEmbededContentSize.Large:
            return EXTRA_EXTRA_LARGE_PANEL_WIDTH;
        case ExtensionEmbededContentSize.FullScreen:
            return FULL_SCREEN_PANEL_WIDTH;
        default:
            return EXTRA_LARGE_PANEL_WIDTH;
    }
}

const ExtensionPanel = (props: OwnProps & StateProps) => {
    const { info } = props;

    if (info.type == ExtensionType.TriggerAction) {
        return <ExtensionTrigger {...props} />
    }

    if (info.type == ExtensionType.OpenNewTab) {
        return <ExtensionNavigate {...props} />
    }

    return <ExpandablePanel
        className="extension-panel"
        isOpen
        type={PanelType.custom}
        customWidth={getExtensionPanelWidth(info.size, props.isFullScreen, props.expandSideBar)}
        onDismiss={() => {
            props.onDismiss();
            props.onRefresh?.();
        }}
        onRenderHeader={() => <Header name={props.info.name}/>}
    >
        <ExtensionViewer context={props.context} entityType={props.entityType} info={props.info} />
    </ExpandablePanel>;
}
function mapStateToProps(state: ApplicationState, ownProps?: OwnProps): StateProps {
    return {
        tenant: state.tenant,
        expandSideBar: state.user.preferences.expandSideBar,
        isFullScreen: state.userInterface.isFullScreen
    };
}

export default connect(mapStateToProps)(ExtensionPanel);